import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "marilandia",
        nomePrefeitura: "Prefeitura Municipal de Marilândia do Sul",
        logo: "marilandia/logos/brasao.png",
        brasao: "marilandia/logos/brasao.png",
        municipio: "| MARILÂNDIA DO SUL - PR",
    },
    webgeo: {
        allowMapDragAtAnyZoom: true,
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape: " - ",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-51.3079588, -23.746638],
            zoom: 18,
        },
    },
    api: {
        url: process.env.REACT_APP_MIGRATION
            ? "https://webgeo-migration.semv.com.br/api/marilandia"
            : "https://api-prd.semv.com.br/marilandia",
    },
    geoserver: {
        url: process.env.REACT_APP_MIGRATION
            ? "https://geoserver-migration.semv.com.br/geoserver"
            : "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
